import * as actionTypes from "./actionTypes";

const initialState = {
    values: {},
    table: {
        data: [],
        sort: {
            property: undefined,
            direction: undefined
        },
        totalElements: undefined,
        pageNumber: undefined,
        totalPages: undefined
    },
    meetingRoomList: [],
    providerList: [],

    //form specific:
    meetingRoomData: {},

    loading: false,
    loadingListRequest: false,
    loadingCreateRequest: false,
    loadingEditRequest: false,
    loadingDeleteRequest: false,
    loadingCalendarEvents: false,

    meetingRoomWasCreated: false,
    meetingRoomWasEdited: false,
    meetingRoomWasDeleted: false,

    meetingRoomScheduleForCalendar: [],

    scheduleEventsTable: {
        loading: false,
        error: undefined,
        data: [],
        sort: {
            property: 'creationTimestamp',
            direction: 'DESC'
        },
        totalElements: undefined,
        pageNumber: undefined,
        totalPages: undefined
    },

    error: undefined
};

const meetingRoomsReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case actionTypes.GET_MEETING_ROOM_PROVIDER_LIST_REQUEST:
            return {
                ...state,
                loadingListRequest: true
            };
        case actionTypes.GET_MEETING_ROOM_PROVIDER_LIST_SUCCESS:
            return {
                ...state,
                loadingListRequest: false,
                providerList: payload
            };
        case actionTypes.MEETING_ROOM_SEARCH_REQUEST:
            return {
                ...state,
                loading: true
            };
        case actionTypes.MEETING_ROOM_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                table: {
                    ...state.table,
                    data: payload.content,
                    totalPages: payload.totalPages,
                    totalElements: payload.totalElements,
                    sort: {
                        direction: payload.sort[0].direction,
                        property: payload.sort[0].property,
                    },
                    pageSize: payload.pageable.pageSize,
                    pageNumber: payload.pageable.pageNumber
                }
            };
        case actionTypes.GET_MEETING_ROOM_REQUEST:
            return {
                ...state,
                loading: true
            };
        case actionTypes.GET_MEETING_ROOM_SUCCESS:
            return {
                ...state,
                loading: false,
                meetingRoomData: payload
            };
        case actionTypes.GET_MEETING_ROOM_FAILED:
            return {
                ...state,
                loading: false,
            };
        case actionTypes.CREATE_MEETING_ROOM_REQUEST:
            return {
                ...state,
                loadingCreateRequest: true,
                error: undefined
            };
        case actionTypes.CREATE_MEETING_ROOM_SUCCESS:
            return {
                ...state,
                loadingCreateRequest: false,
                meetingRoomWasCreated: true,
                error: undefined
            };
        case actionTypes.CREATE_MEETING_ROOM_FAILED:
            return {
                ...state,
                loadingCreateRequest: false,
                meetingRoomWasCreated: false,
                error: payload
            };
        case actionTypes.EDIT_MEETING_ROOM_REQUEST:
            return {
                ...state,
                loadingEditRequest: true,
                error: undefined
            };
        case actionTypes.EDIT_MEETING_ROOM_SUCCESS:
            return {
                ...state,
                loadingEditRequest: false,
                meetingRoomWasEdited: true,
                error: undefined
            };
        case actionTypes.EDIT_MEETING_ROOM_FAILED:
            return {
                ...state,
                loadingEditRequest: false,
                meetingRoomWasEdited: false,
                error: payload
            };
        case actionTypes.DELETE_MEETING_ROOM_REQUEST:
            return {
                ...state,
                loadingDeleteRequest: true
            };
        case actionTypes.DELETE_MEETING_ROOM_SUCCESS:
            return {
                ...state,
                loadingDeleteRequest: false,
                meetingRoomWasDeleted: true
            };
        case actionTypes.DELETE_MEETING_ROOM_FAILED:
            return {
                ...state,
                loadingDeleteRequest: false,
                meetingRoomWasDeleted: false
            };
        case actionTypes.RESET_MEETING_ROOMS_FORM:
            return {
                ...state,
                meetingRoomData: {},
                loading: false,
                loadingListRequest: false,
                loadingCreateRequest: false,
                loadingEditRequest: false,
                loadingDeleteRequest: false,
                meetingRoomWasCreated: false,
                meetingRoomWasEdited: false,
                meetingRoomWasDeleted: false,
                error: undefined,
                meetingRoomScheduleForCalendar: [],
                scheduleEventsTable: {
                    loading: false,
                    error: undefined,
                    data: [],
                    sort: {
                        property: 'creationTimestamp',
                        direction: 'DESC'
                    },
                    totalElements: undefined,
                    pageNumber: undefined,
                    totalPages: undefined
                }
            };
        case actionTypes.GET_SCHEDULED_EVENTS_FOR_CALENDAR_REQUEST:
            return {
                ...state,
                loadingCalendarEvents: true,
            };
        case actionTypes.GET_SCHEDULED_EVENTS_FOR_CALENDAR_SUCCESS:
            return {
                ...state,
                loadingCalendarEvents: false,
                meetingRoomScheduleForCalendar: payload,
            }
        case actionTypes.GET_SCHEDULED_EVENTS_FOR_CALENDAR_FAILED:
            return {
                ...state,
                loadingCalendarEvents: false,
            }
        case actionTypes.SCHEDULE_EVENT_ENTRIES_SEARCH_REQUEST:
            return {
                ...state,
                scheduleEventsTable: {
                    ...state.scheduleEventsTable,
                    loading: true
                }
            };
        case actionTypes.SCHEDULE_EVENT_ENTRIES_SEARCH_SUCCESS:
            return {
                ...state,
                scheduleEventsTable: {
                    ...state.scheduleEventsTable,
                    loading: false,
                    data: payload.content,
                    totalPages: payload.totalPages,
                    totalElements: payload.totalElements,
                    sort: {
                        direction: payload.sort[0].direction,
                        property: payload.sort[0].property,
                    },
                    pageSize: payload.pageable.pageSize,
                    pageNumber: payload.pageable.pageNumber
                }
            };
        case actionTypes.SCHEDULE_EVENT_ENTRIES_SEARCH_FAILED:
            return {
                ...state,
                scheduleEventsTable: {
                    ...state.scheduleEventsTable,
                    loading: false,
                    error: payload
                }
            };
        default:
            return state;
    }
};

export default meetingRoomsReducer;